﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 261012
    Description: Functions to work with _DlgSearc.ctml styled with bootstrap
*/
'use strict';

const searchTagAdded = () => {
    setTagsVisibility();
    $('#searchBox').val('');
}

const setTagsVisibility = () => {
    if ($('#searchTags').val().length > 0) {
        $('#divSearchTags').removeClass('hidden');
    } else {
        $('#divSearchTags').addClass('hidden');
    }
}

const hideSearchSelectList = () => {
    $('#divSearch').removeClass('hidden');
    $('#divSelectList').addClass('hidden');
    setTagsVisibility();
}

const initSearch = params => {
    if (!params.source && !params.fnSource) {
        alert('params.source or params.fnSource is required for search dialog!');
        return;
    }

    const autocompleteOptions = {
        source: params.source ?? params.fnSource
    };
    if (params.fnSelect) {
        autocompleteOptions.select = params.fnSelect;
    }
    $('#searchBox').autocomplete(autocompleteOptions);

    const searchTags = $('#searchTags');
    searchTags.tagsinput('add', ''); // Initialize control - else 1st tag is never displayed

    const fnSearchTagAdded = params.fnSearchTagAdded
        ? () => { params.fnSearchTagAdded(); searchTagAdded(); }
        : searchTagAdded;

    const fnSearchTagRemoved = params.fnSearchTagRemoved
        ? () => { params.fnSearchTagRemoved(); setTagsVisibility(); }
        : setTagsVisibility;

    searchTags.on('itemAdded', fnSearchTagAdded);

    if (params.fnBeforeRemoveTag) {
        searchTags.on('beforeItemRemove', params.fnBeforeRemoveTag);
    }

    searchTags.on('itemRemoved', fnSearchTagRemoved);

    $('#btnHideSelectList').on('click', () => { hideSearchSelectList(); });

};

export {
    initSearch
}; 
